import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import GlossaryTermDefinition from './GlossaryTermDefinition';

interface SectionTextGlossaryTermProps {
  originalText: string;
  termId: number;
  displayDefinitionOnLoad?: boolean,
}

const SectionTextGlossaryTerm = ({ originalText, termId, displayDefinitionOnLoad }: SectionTextGlossaryTermProps) => {
  const termRef = useRef<HTMLDivElement>(null);
  const [showDefinition, setShowDefinition] = useState(displayDefinitionOnLoad ?? true);
  const [glossaryTerm, setGlossaryTerm] = useState(null);

  useEffect(() => {
    axios.get(Routes.plato_api_glossary_term_path(termId))
      .then(res => setGlossaryTerm(res.data.glossary_term))
      // AIDEV-NOTE: stale data-term-id values exist in saved section HTML; keep the text, drop the definition
      .catch(() => setGlossaryTerm(null));
  }, []);

  return (
    <>
      <strong
        ref={termRef}
        className="glossary-text tw-underline tw-cursor-pointer"
        role="button"
        onClick={() => setShowDefinition(prev => !prev)}
      >
        {originalText}
      </strong>
      {glossaryTerm && (
        <GlossaryTermDefinition
          buttonRef={termRef}
          glossaryTerm={glossaryTerm}
          setShowDefinition={setShowDefinition}
          showDefinition={showDefinition}
        />
      )}
    </>
  );
};

export default SectionTextGlossaryTerm;
